import { v4 as uuidv4 } from "uuid";
// initial state
export const initialInputs: InputByLevelRanking[] = [
    { id: uuidv4(), label: "", fAmount: 0 },
    { id: uuidv4(), label: "", fAmount: 0 },
];

export interface LevelRankingState {
    inputs: InputByLevelRanking[],
    riders?: LevelRankingRider[];
}

export interface LevelRankingRider {
    id: number;
    label: string;
    inputs: InputByLevelRanking[];
}

export interface InputByLevelRanking {
    label: string;
    fAmount: number;
    id: string
}

// Payload
export interface AddRiderLevelRankingInputPayload {
    id: number; 
    label: string; 
    inputs?: { label: string; fAmount: number }[]
    values?: { designation: string; amount: number }[];
    riderValues?: InputByLevelRanking[];
}

// State
export interface ProposalLevelRanking {
    designation: string;
    amount: number;
    total_coverage_amount: number;
}